export interface Precio {
  id: string;
  icon: string;
  title: string;
  price: string;
  desc: string;
  servicio: "persianas" | "mosquiteras" | "motorizacion" | "general";
}

export const precios: Precio[] = [
  {
    id: "cambio-cinta",
    icon: "ri-scissors-cut-line",
    title: "Cambio de cinta de persiana",
    price: "desde 45 €",
    desc: "Sustitución de la cinta desgastada o rota. Todos los anchos y colores en stock. Reparación en 30-45 minutos. Revisión de poleas incluida.",
    servicio: "persianas",
  },
  {
    id: "persiana-atascada",
    icon: "ri-error-warning-line",
    title: "Reparación persiana atascada",
    price: "desde 50 €",
    desc: "Desatasco de persianas bloqueadas, descolgadas o que no corren. Reajuste del eje, limpieza de rieles y ajuste de holguras en menos de 1 hora.",
    servicio: "persianas",
  },
  {
    id: "cambio-motor",
    icon: "ri-settings-3-line",
    title: "Cambio de motor de persiana",
    price: "desde 120 €",
    desc: "Sustitución de motor tubular averiado por uno nuevo. Motores Somfy y Nice con mando a distancia. Instalación limpia sin obras en 1 hora.",
    servicio: "motorizacion",
  },
  {
    id: "cambio-lamas",
    icon: "ri-stack-line",
    title: "Cambio de lamas",
    price: "desde 70 €",
    desc: "Sustitución de lamas rotas, dobladas o agrietadas en aluminio con espuma, PVC y madera. Solo cambiamos las dañadas, sin cambiar toda la persiana.",
    servicio: "persianas",
  },
  {
    id: "recogedor-poleas",
    icon: "ri-uninstall-line",
    title: "Cambio de recogedor y poleas",
    price: "desde 40 €",
    desc: "Sustitución de recogedor desprendido o con mecanismo roto. Cambio de poleas desgastadas. Fijación reforzada en todo tipo de pared. En 20-30 min.",
    servicio: "persianas",
  },
  {
    id: "reparacion-madera",
    icon: "ri-tree-line",
    title: "Reparación persiana de madera",
    price: "desde 55 €",
    desc: "Lijado de lamas hinchadas, ajuste de holguras, tratamiento antihumedad. Sustitución de lamas deterioradas. Trabajo cuidadoso con carpintería original.",
    servicio: "persianas",
  },
  {
    id: "motorizacion",
    icon: "ri-flashlight-line",
    title: "Motorización de persiana (sin obras)",
    price: "desde 120 €",
    desc: "Convierte tu persiana manual de cinta o manivela en motorizada. Instalación limpia en 1-2 horas. Mando a distancia incluido. Motores Somfy y Nice.",
    servicio: "motorizacion",
  },
  {
    id: "revision-mantenimiento",
    icon: "ri-restart-line",
    title: "Revisión y mantenimiento",
    price: "desde 30 €",
    desc: "Revisión completa de persianas y mosquiteras. Limpieza de rieles, engrase de mecanismos, ajuste de tensores. Alarga la vida de tu instalación.",
    servicio: "general",
  },
  {
    id: "mosquitera-medida",
    icon: "ri-shield-check-line",
    title: "Mosquitera a medida",
    price: "desde 60 €",
    desc: "Fabricación e instalación de mosquiteras enrollables a la medida exacta de tu ventana. Perfiles de aluminio lacado. Malla de fibra de vidrio de alta transparencia.",
    servicio: "mosquiteras",
  },
  {
    id: "reparacion-mosquitera",
    icon: "ri-tools-line",
    title: "Reparación de mosquitera",
    price: "desde 35 €",
    desc: "Cambio de muelle de recogida, sustitución de malla dañada, ajuste de guías. Arreglamos tu mosquitera actual si tiene solución. Más barato que cambiarla.",
    servicio: "mosquiteras",
  },
];

export const preciosPorServicio: Record<string, string[]> = {
  persianas: ["cambio-cinta", "persiana-atascada", "cambio-lamas", "recogedor-poleas", "reparacion-madera", "cambio-motor", "motorizacion", "revision-mantenimiento"],
  mosquiteras: ["mosquitera-medida", "reparacion-mosquitera", "revision-mantenimiento"],
  motorizacion: ["motorizacion", "cambio-motor", "revision-mantenimiento"],
};